import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { SingleOfferFragment } from '../../../graphql/generated/graphql_offer';
import { SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';

type Props = TypographyProps & {
  offer: Pick<SingleOfferFragment, 'rewardCurrency' | 'rewardAmount'>;
  isAvailable: boolean;
  displayRewardText?: boolean;
  className?: string;
};

const OfferRewardDisplay = ({
  offer,
  isAvailable,
  displayRewardText,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  const ColoredRoot = styled(Root)(
    isAvailable
      ? {
          backgroundColor: '#1DA772',
        }
      : {
          backgroundColor: '#E2E6EF',
        },
  );

  const ColoredAdoptionReward = styled(AdoptionReward)(
    isAvailable
      ? {
          color: '#FFF',
        }
      : {
          color: '#FFF',
        },
  );

  const ColoredRewardAmount = styled(RewardAmount)(
    isAvailable
      ? {
          color: '#FFF',
        }
      : {
          color: '#FFF',
        },
  );

  return (
    <ColoredRoot className={className}>
      <Grid container direction="row" justify="center" alignItems="center">
        {displayRewardText && (
          <Grid item>
            <ColoredAdoptionReward>
              <FormattedMessage id="offer_reward_display.competition_reward.label" />
            </ColoredAdoptionReward>
          </Grid>
        )}
        <Grid item>
          <ColoredRewardAmount>
            <FormattedNumber
              style="currency"
              currencyDisplay="symbol"
              maximumFractionDigits={0}
              minimumFractionDigits={0}
              currency={offer.rewardCurrency === null ? undefined : offer.rewardCurrency}
              value={offer.rewardAmount}
            />
          </ColoredRewardAmount>
        </Grid>
      </Grid>
    </ColoredRoot>
  );
};

const Root = styled('div')({
  padding: `${SPACING_UNIT / 2}px ${SPACING_REGULAR}px`,
  display: 'flex',
});

const AdoptionReward = styled(Typography)({
  fontWeight: 400,
  fontSize: 12,
  marginRight: SPACING_UNIT / 2,
  marginTop: SPACING_UNIT / 2,
});

const RewardAmount = styled(Typography)({
  fontWeight: 500,
  fontSize: 18,
  textAlign: 'center',
});

export default OfferRewardDisplay;
